import React, { useState } from 'react';
import Button from '@mui/material/Button';

const CustomButton = (props) => {
    const [isDisabledBt, setIsDisabledBt] = useState(false);

    const handleClick = () => {
        if (!isDisabledBt) {
            setIsDisabledBt(true);
            props.onClick();
        }
    };

    return (
        <Button
            {...props}
            onClick={handleClick}
            disabled={isDisabledBt || props.disabled}
        />
    );
};

export default CustomButton;